import { render, staticRenderFns } from "./ConversationItem.vue?vue&type=template&id=5c007c7f&scoped=true"
import script from "./ConversationItem.vue?vue&type=script&lang=js"
export * from "./ConversationItem.vue?vue&type=script&lang=js"
import style0 from "./ConversationItem.vue?vue&type=style&index=0&id=5c007c7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c007c7f",
  null
  
)

export default component.exports